import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- constants
import ViewConstants from 'constants/ViewConstants';
import ViewUtils from 'PMT/utils/ViewUtils';
import ColorPickerViewUtils from 'utils/ColorPickerViewUtils';

// -- views
import { Modal } from 'react-bootstrap';
import ColorPickerColorView from './ColorPickerColorView';
import ColorPicker from 'react-color';


class ColorPickerModal extends Component {

  static defaultProps = {
    color: ViewUtils.hexadecimalColorToUint(ViewConstants.ColorPicker.DEFAULT_COLOR),
    colorsList: ColorPickerViewUtils.getDefaultColorListUint()
  };

  static propTypes = {
    // -- colors

    // uint color
    color: PropTypes.number,

    // array of uint
    colorsList: PropTypes.arrayOf(Number),

    // -- modal

    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    // params: color (int value)
    onChange: PropTypes.func.isRequired
  };

  state = {
    color: this.props.color
  };

  // -- events colors

  submit = (event) => {
    event.preventDefault();

    if (!_.isNull(this.state.color)) {
      this.props.onChange(this.state.color);
    } else {
      this.props.onHide();
    }
  };

  onColorChosen = (color) => {
    this.setState({
      color
    });
  };

  /**
   * See http://casesandberg.github.io/react-color/#api-onChange
   * @param color
   */
  onColorPickerChange = (color: Object) => {
    const uintValue = ViewUtils.rgbaToUint(color.rgb);
    this.setState({
      color: uintValue
    });
  };

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  // -- tools
  // -- renderers

  renderBody() {
    const colorListView = [];

    this.props.colorsList.forEach((color) => {
      // get the current color.
      let currentColor = this.state.color;
      if (_.isNull(currentColor)) {
        currentColor = this.props.color;
      }

      const isSelected = color === currentColor;

      colorListView.push(
        <ColorPickerColorView
          color={color}
          isSelected={isSelected}
          onClicked={this.onColorChosen}
          key={color}
        />
      );
    });

    return (
      <div className="color_picker">
        <div className="row">
          <div className="color_picker__list col-sm-12 col-md-6 vcenter-md vcenter-lg">
            {colorListView}
          </div>

          <div
            className="color_picker__react_color_picker top-buffer-xs-50 top-buffer-sm-50 col-sm-12 col-md-6 vcenter-md vcenter-lg"
          >
            <ColorPicker
              display
              onClose={() => { }}
              type="sketch"
              color={ViewUtils.uintToRgba(this.state.color)}
              onChange={this.onColorPickerChange}
            />
          </div>
        </div>

        <div className="text-center top-buffer-50">
          <button
            className="btn btn-primary"
            type="submit"
            onClick={this.submit}
          >
            {I18n.tr('components.color.picker.validate')}
          </button>
        </div>

      </div>);
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.color.picker.modal_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}

export default ColorPickerModal;
